import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { CreditService } from './shared/credit.service'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [CreditService]
})
export class ConsumablesModule { }

export { CreditService }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/consumables/consumables.module.ts